module.exports = __webpack_public_path__ + "static/dvma-98afc9394bdcb968834cc36e8532adf9.png";